<template>
<div>
  <h2 class="mb-4">配置基準設定</h2>
  <placement-setting-container />
</div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

import PlacementSettingContainer from '@/containers/work-schedule/PlacementSettingContainer.vue'

export default defineComponent({
  components: {
    PlacementSettingContainer,
  },
})

</script>
